import { useIdleTimer } from "react-idle-timer"

/**
 * @param onIdle - function to notify user when idle timeout is close
 * @param idleTime - number of seconds to wait before user is logged out
 */

const useIdleTimeout = ({ onIdle, onPrompt, idleTime = 1, promptTime = 0 }) => {
    const idleTimeout = 1000 * idleTime;
    const promptTimeout = 1000 * promptTime;

    const idleTimer = useIdleTimer({
        timeout: idleTimeout,
        promptBeforeIdle: promptTimeout,
        crossTab: true,
        onPrompt: onPrompt,
        onIdle: onIdle,
        debounce: 500
    });

    return {
        idleTimer
    }
}

export default useIdleTimeout;